import { httpPost } from "shared/api/apiHandler";
import urls from "shared/api/auth/urls";
import BooleanResponseWithErrors from "shared/models/booleanResponseWithErrors";

export const requestPhoneVerification = async (
    phone: string,
    userId?: string | number
): Promise<BooleanResponseWithErrors> => {
    let data: { phone: string; userId?: string | number } = { phone };

    if (userId) {
        data = { ...data, userId };
    }

    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.authApiBaseUri,
        urls.PHONE_VERIFICATION.ROOT,
        data
    );

    return result.data;
};

export const requestCodeVerification = async (
    phone: string,
    code: string,
    userId?: string | number
): Promise<BooleanResponseWithErrors> => {
    let data: { phone: string; code: string; userId?: string | number } = { phone, code };

    if (userId) {
        data = { ...data, userId };
    }

    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.authApiBaseUri,
        urls.PHONE_VERIFICATION.VERIFIED,
        data
    );

    return result.data;
};
